import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {FileUploader} from 'ng2-file-upload';

const componentBaseName = 'file-upload';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName];

@Component({
  selector: 'cat-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  @HostBinding('class') classNames = [...defaultClassNames, this.classNames].join(' ');

  @Output() itemSuccess = new EventEmitter<any>();
  @Output() itemError = new EventEmitter<any>();
  @Input() uploaderHandler = {uploadAll: (url: string) => {}};

  uploader: FileUploader = new FileUploader({});

  countFileList = 0;
  hasBaseDropZoneOver = false;

  constructor() {
  }

  ngOnInit() {

    this.uploader.onSuccessItem = (item, response, status, headers) => {
      this.itemSuccess.emit({item, response, status, headers});
    };

    this.uploader.onErrorItem = (item, response, status, headers) => {
      this.itemError.emit({item, response, status, headers});
    };

    this.uploaderHandler.uploadAll = (url) => {
      this.uploader.setOptions({url});
      this.uploader.uploadAll();
    };
  }

  public fileDrop(fileList: FileList): void {
    this.countFileList = fileList.length;
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/file-upload/file-upload.component.ts